module.exports = "/assets/d21adb10cbeba94b97f32ac11b8af522.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/DT.png
// module id = 1313
// module chunks = 0